import yVaultsArbitrum from '../../../Fct/tokens/yearnVaultsArbitrum.json';
import yVaultsMainnet from '../../../Fct/tokens/yearnVaultsMainnet.json';
export var getyVaults = function (_a) {
    var chainId = _a.chainId;
    if (chainId === '42161')
        return yVaultsArbitrum;
    return yVaultsMainnet;
};
